<template>
  <el-dialog
    :visible.sync="showModal"
    class="welcome-to-premium"
    data-test="dialogbox-welcomepremium"
    @close="explorePodcasts"
  >
    <h2 class="welcome-to-premium__title">
      Welcome to Luminary Premium
    </h2>

    <div class="welcome-to-premium__description">
      <p>Enjoy our collection of Premium shows.</p>
      <p v-if="isFirstSubscription">Your sign up is complete and your free trial has started.</p>
    </div>

    <el-button
      class="welcome-to-premium__explore"
      type="primary"
      data-test="btn-explorePodcasts"
      @click="explorePodcasts"
    >
      Explore Podcasts
    </el-button>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set() {

      },
    },
    isFirstSubscription() {
      const { userSubscription } = this.$store.getters;
      return userSubscription && userSubscription.is_first_subscription;
    },
  },
  methods: {
    explorePodcasts() {
      this.$emit('closeWelcomeModal');
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";

.welcome-to-premium {
  .el-dialog {
    background-color: $brand;
    border-radius: 7px;
    text-align: center;
    padding: 70px;

    margin-top: 0 !important;

    display: inline-block;

    width: auto;

    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);

    &__body {
      padding: 0;
    }

    &__header {
      padding: 0;
    }

    @media (max-width: 767px) {
      top: 0;
      left: 0;
      transform: none;

      width: 100%;
      height: 100%;
      border-radius: 0;

      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__title {
    font-size: 40px;
    color: $black;

    margin: 0;
  }

  &__description {
    margin: 30px 0 45px;

    > p {
      color: $black;
      font-size: 16px;
    }
  }

  &__explore {
    padding: 14px 30px;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/WelcomeToPremium.vue